import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden bg-background-100">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20carefully%20curated%20lifestyle%20and%20fashion%20pieces%20including%20folded%20linen%20shirts%20suede%20sneakers%20leather%20watch%20and%20ceramic%20coffee%20cup%20arranged%20in%20an%20organic%20flowing%20composition%20on%20warm%20sand%20colored%20canvas%20fabric%20surface%2C%20soft%20diffused%20morning%20light%20from%20large%20window%2C%20minimal%20shadows%2C%20warm%20sand%20cream%20and%20taupe%20color%20palette%2C%20editorial%20catalog%20aesthetic%20with%20generous%20negative%20space%20and%20gentle%20texture%2C%20sophisticated%20modern%20simplicity&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet Product Discovery - Fashion items flat lay"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-16">
            <div className="flex-1 w-full">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-extrabold text-background-50 leading-[1.08] tracking-tight">
                The Most Complete<br />
                <span className="text-accent-300">Hipobuy Spreadsheet</span><br />
                Database 2026
              </h1>
              <p className="mt-6 text-base md:text-lg text-background-200/90 max-w-lg leading-relaxed">
                Discover organized product spreadsheets, verified finds, comparisons, and shopping guides designed to help buyers make smarter decisions.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center gap-2 bg-accent-500 text-foreground-950 px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer group"
                >
                  Start Exploring
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
                <Link
                  to="/hipobuy-spreadsheet-guide"
                  className="inline-flex items-center justify-center gap-2 border border-background-300/40 text-background-50 px-8 py-3.5 rounded-lg text-base font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer group"
                >
                  Read the Guide
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>

            <div className="flex-1 w-full hidden lg:block">
              <div className="relative">
                <div className="w-full h-[420px] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20boutique%20display%20featuring%20wooden%20shelving%20unit%20with%20neatly%20arranged%20folded%20sweaters%20rolled%20jeans%20and%20leather%20accessories%20against%20warm%20plaster%20wall%2C%20soft%20spotlight%20illumination%20highlighting%20product%20textures%20and%20colors%2C%20warm%20beige%20terracotta%20and%20cream%20palette%2C%20high%20end%20retail%20interior%20photography%20with%20shallow%20depth%20of%20field%20focusing%20on%20central%20display%2C%20refined%20commercial%20aesthetic%20with%20organic%20styling&width=1000&height=700&seq=hero-showcase-v2&orientation=landscape"
                    alt="Curated fashion products showcase"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}